import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Button, Modal, Header } from 'semantic-ui-react';
import { UserStore, UserDto } from 'stores/users/users-store';
import { connect } from 'redux-scaffolding-ts';
import TailwindMultipleEmployeeEditor from 'widgets/bussiness/multiple-selector/multiple-employee-editor-tw';
import { StudentDto } from 'stores/students/student-model';

interface TailwindChooseStudentsViewProps extends WithTranslation {
  onAddParticipants?: (students: UserDto[]) => void;
  onCloseUsersModal?: () => void;
  students?: StudentDto[];
  alreadySelectedUserIds?: string[];
  usersStore?: UserStore;
  locationIds?: string[];
  positionCodeIds?: string[];
  maxSelection?: number;
  addButtonText?: string;
  selectionRequired?: boolean;
  showSFPositionFields?: boolean;
  showPositionCodeFields?: boolean;
}

interface TailwindChooseStudentsViewState {
  selectedUsers: UserDto[];
}

@connect(['usersStore', UserStore])
class TailwindChooseStudentsView extends Component<TailwindChooseStudentsViewProps, TailwindChooseStudentsViewState> {
  constructor(props: TailwindChooseStudentsViewProps) {
    super(props);
    this.state = {
      selectedUsers: []
    };
  }

  private onCancel = () => {
    this.props.onCloseUsersModal();
  };

  selectedUsers(items: unknown[]): void {
    const itemsToAdd = (items as UserDto[]).filter(item => !this.props.students?.some(student => student.id === item.id));
    this.setState({ selectedUsers: items as any });
    this.props.onAddParticipants(itemsToAdd as any);
  }

  public render() {
    const { t } = this.props;

    return (
      <Modal
        size="large"
        className="employee-search__modal search__modal"
        open
        closeOnEscape={true}
        onClose={this.onCancel}
        closeOnDimmerClick={false}
      >
        <Modal.Header className="search__modal__header">
          <Header as="h2" className="modal-header-title">
            {t('Employee Search')}
          </Header>
        </Modal.Header>
        <Modal.Content className="modal-content">
          <div className="student-list-table">
            <TailwindMultipleEmployeeEditor
              clearable
              placeholder={t('Employee Name')}
              role="Employee"
              locationIds={[]}
              value={this.props.students || []}
              onChange={users => this.selectedUsers(users)}
            />
          </div>
        </Modal.Content>

        <Modal.Actions>
          <Button className="basic" onClick={this.onCancel}>
            {t('Close')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(TailwindChooseStudentsView);
